import PropTypes from 'prop-types';

export default function PlayerTableRowRenderer({ item: playerItem, handleSelectItem, handleItemClicked }) {
  const { id: primaryKey, selected: isSelected, userName, hash, description, name } = playerItem;

  const onCheckBoxChange = () => {
    handleSelectItem(primaryKey, !isSelected);
  };

  return (
    <tr className={`body-row ${isSelected ? 'selected' : ''}`}>
      <td className="user-select">
        {handleSelectItem && (
          <input className="user-checkbox" type="checkbox" checked={isSelected} onChange={onCheckBoxChange} />
        )}
      </td>
      <td className="body-row-name">
        {handleItemClicked ? (
          <button
            type="button"
            className="body-row-name-link btn text"
            onClick={() => handleItemClicked(primaryKey, hash)}
          >
            {name}
          </button>
        ) : (
          <span className="body-row-name">{name}</span>
        )}
      </td>
      <td className="player-description">{description}</td>
      <td className="player-creator">{userName}</td>
    </tr>
  );
}

PlayerTableRowRenderer.defaultProps = {
  handleSelectItem: null,
  handleItemClicked: null,
};

PlayerTableRowRenderer.propTypes = {
  handleSelectItem: PropTypes.func,
  handleItemClicked: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.string,
    selected: PropTypes.bool,
    userName: PropTypes.string,
    hash: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};
